import React from 'react';
import PrimaryButton from '../shared/PrimaryButton';
import SecondaryButton from '../shared/SecondaryButton';
import {
  EMERGENCY_HOURS,
  FOUNDED_YEAR,
  HVAC_LICENSE,
  PHONE_NUMBER,
  PHONE_NUMBER_LINK,
  PRIMARY_CTA_TEXT,
  SECONDARY_CTA_TEXT,
} from '../../data/contact';

const HeroSection = () => (
  <section className="home-hero section">
    <div className="container home-hero-grid">
      <div className="home-hero-copy">
        <p className="section-eyebrow">Salt Lake County HVAC Services</p>
        <h1>Reliable heating and cooling service for homes across Salt Lake County.</h1>
        <p className="home-hero-text">
          Whether you need a fast repair, seasonal maintenance, or help planning a system replacement,
          we provide straightforward HVAC service designed around comfort, timing, and budget.
        </p>

        <div className="hero-actions">
          <PrimaryButton to="/contact">{PRIMARY_CTA_TEXT}</PrimaryButton>
          <SecondaryButton href={PHONE_NUMBER_LINK} aria-label={`Call Now at ${PHONE_NUMBER}`}>
            {SECONDARY_CTA_TEXT}
          </SecondaryButton>
        </div>

        <div className="hero-highlight card">
          <strong>Repairs, tune-ups, replacements, and indoor air comfort solutions.</strong>
          <ul className="hero-credential-list" aria-label="Preferred Service credentials">
            <li>Family-owned and serving local customers since {FOUNDED_YEAR}</li>
            <li>Utah HVAC Qualifier license #{HVAC_LICENSE}</li>
            <li>{EMERGENCY_HOURS}</li>
          </ul>
        </div>
      </div>

      <div className="home-hero-media">
        <img
          src="/home-hero-800.webp"
          alt="HVAC technician checking residential equipment"
          width="800"
          height="1201"
          decoding="async"
          fetchPriority="high"
        />
      </div>
    </div>
  </section>
);

export default HeroSection;
